import React, { Component } from 'react';
import Menu from 'components/Menu';

export default function withMenu(WrappedComponent, leaveForRight) {
  return class WithMenu extends Component {
    static defaultProps = {
      withBackButton: false,
    };

    render() {
      return (
        <>
          <Menu leaveForRight={leaveForRight} />
          <WrappedComponent {...this.props} />
        </>
      );
    }
  };
}
